<template>
  <div class="device-select">
    <el-dialog title="选择设备" :visible.sync="deviceVisible" append-to-body :close-on-click-modal="deviceModalClose"
      @close="handleSelectCancel" width="42%">
      <el-form :model="queryForm" ref="queryForm" :inline="true">
        <el-form-item label="设备类型">
          <el-select v-model="queryForm.deviceType" placeholder="请选择设备类型">
            <el-option v-for="item in deviceTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearchDevice">查询</el-button>
          <el-button @click="handleResetDevice">重置</el-button>
        </el-form-item>
      </el-form>
      <div>
        <el-table :data="deviceData" @selection-change="handleSelectionChange"
          style="width: 100%; max-height: 470px; overflow-y: auto;">
          <el-table-column width="50">
            <template slot-scope="scope">
              <el-radio v-model="selectRadio" :label="scope.row">{{""}}</el-radio>
            </template>
          </el-table-column>
          <el-table-column label="序号" type="index" width="70"></el-table-column>
          <el-table-column label="设备编码" prop="deviceId" show-overflow-tooltip></el-table-column>
          <el-table-column label="设备名称" prop="deviceName" show-overflow-tooltip></el-table-column>
          <el-table-column label="设备类型" prop="deviceTypeName" show-overflow-tooltip></el-table-column>
          <el-table-column label="设备状态" prop="statusName" show-overflow-tooltip></el-table-column>
          <el-table-column label="设备位置" prop="location" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSelectConfirm">确 定</el-button>
        <el-button @click="handleSelectCancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
export default {
  name: 'DeviceSelect',
  data() {
    return {
      // 选择设备
      deviceVisible: false,
      deviceModalClose: false,
      queryForm: {
        deviceType: ''
      },
      // 设备类型
      deviceTypeList: [],
      // 设备列表
      deviceData: [],
      // 选中项
      selectRadio: '',
      confirmArr: []
    }
  },
  created() {
    this.queryDeviceType()
    this.queryDeviceList()
  },
  methods: {
    openDialog() {
      this.deviceVisible = true;
    },
    handleSelectionChange(row) {
      this.selectRadio = row
    },
    // 查询设备类型
    queryDeviceType() {
      this.$fetch(api.getDeviceType).then((res) => {
        this.deviceTypeList = res.returnObj.map((item) => {
          return {
            label: item.deviceTypeName || "",
            value: item.deviceTypeId || "",
          };
        });
      });
    },
    // 查询设备
    queryDeviceList() {
      this.$fetch(api.getDeviceList, {
        page: 1,
        pageSize: 100000,
        deviceType: this.queryForm.deviceType
      }).then((res) => {
        if (res.success) {
          this.deviceData = res.returnObj.list
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 查询所有设备
    handleSearchDevice() {
      this.queryDeviceList();
    },
    // 重置查询所有设备
    handleResetDevice() {
      this.queryForm.deviceType = ''
      this.queryDeviceList();
    },
    handleSelectCancel() {
      this.selectRadio = '';
      this.deviceVisible = false;
    },
    locationRender(row) {
      return row.longitude + ',' + row.latitude
    },
    // 传值
    handleSelectConfirm() {
      if (this.selectRadio == '') {
        this.$message({
          message: '请选择设备',
          type: 'warning'
        });
        return
      }
      this.$emit('selectArr', this.selectRadio)
      this.handleSelectCancel();
    }
  }
}
</script>
